import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: row;
  height: 40px;
  padding: 5px;
  background-color: #FFF8E7;
  font-size: 13px;
  font-weight: bold;
  color: #3D4F59;
  justify-content: center;
  align-items: center;

  .updater-icon-container {
    display: flex;
    flex-grow: 1;
    margin-left: 8px;
  }

  .text-container {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    span {
      font-size: 13px;
    }

    a {
      font-size: 13px;
      color: #77A2DA !important;
      text-decoration: none;
    }
    
    a:focus {
      outline: none;
    }

    a:visited, a:active {
      color: ${colors.blue};
    }
  }

  .button-container {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
  }

  .close-icon-container {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
  }
`;

export const CloseIcon = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-weight: 700;
  font-size: 16px;
  border-radius: 100px;
  color: #5E5E5E;

  &:before {
    content: "x";
  }

  &:hover {
    cursor: pointer;
    background-color: ${colors.white};
    color: ${colors.darkBlue02};
    opacity: .7;
  }
`;

export const AcceptUpdateButton = lib.styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 85px;
  height: 26px;
  font-size: 13px;
  font-weight: 800;
  font-family: Nunito!important;
  color: #FFF;
  border-width: 0px;
  border-radius: 50px;
  cursor: pointer;
  background: linear-gradient(50.28deg,#58ab40 2.79%,#62bb46 73.37%);

  &:focus {
    outline: 0;
  }

  &:lang(fr) {
    font-size: 12px;
  } 
  
  &:lang(de) {
    font-size: 11px;
  } 
`;
